import { IAttribute, IViolation } from 'app/model/base/annotation';
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { FormatDatasetV2 } from 'app/model/dataset/dataset.v2';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'Excel',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.ModelName_ExcelDataset),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.ModelName_ExcelDataset)
    ]
})
export class ExcelDataset extends FormatDatasetV2 {
    public static readonly MODEL: IModel;
    public static readonly SHEET_NAME: IAttribute;
    public static readonly SHEET_INDEX: IAttribute;
    public static readonly RANGE: IAttribute;
    public static readonly FIRSTROW_ASHEADER?: IAttribute;
    public static readonly COMPRESSION_CODEC?: IAttribute;
    public static readonly COMPRESSION_LEVEL?: IAttribute;
    public static readonly NULL_VALUE?: IAttribute;

    public useSheetName: boolean = true;

    @Metamodel.attribute({
        templatable: true,
        association: 'SHEET_NAME',
        display: stringResources.ModelName_SheetName,
        constraint: {
            validator: ExcelDataset.validateSheetName
        }
    })
    public sheetName: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'SHEET_INDEX',
        display: stringResources.ModelName_SheetIndex,
        constraint: {
            validator: ExcelDataset.validateSheetIndex
        }
    })
    public sheetIndex: number;

    @Metamodel.attribute({
        templatable: true,
        association: 'RANGE',
        display: stringResources.Dataset_FileFormat_RowDelimiterFieldLabel
    })
    public range?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'FIRSTROW_ASHEADER',
        display: stringResources.ModelName_FirstRowAsHeader
    })
    public firstRowAsHeader?: boolean;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_CODEC',
        accepts : ['String'],
        display: stringResources.ModelName_CompressionCodec
    })
    public compressionCodec?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'COMPRESSION_LEVEL',
        display: stringResources.ModelName_CompressionLabel
    })
    public compressionLevel?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'NULL_VALUE',
        display: stringResources.NullValueFieldLabel
    })
    public nullValue?: string;

    public static validateSheetName(dataset: ExcelDataset, sheetName: string): IViolation[] {
        if (dataset.useSheetName && !ExcelDataset.SHEET_NAME.templateValue(dataset) && !sheetName) {
            return [{
                message: () => stringResources.Empty_WorkSheetName_Error_Message,
                context: dataset
            }];
        }
        return [];
    }

    public static validateSheetIndex(dataset: ExcelDataset, sheetIndex: number): IViolation[] {
        if (!dataset.useSheetName && !ExcelDataset.SHEET_INDEX.templateValue(dataset) && sheetIndex == null) {
            return [{
                message: () => stringResources.Empty_WorkSheetName_Error_Message,
                context: dataset
            }];
        }
        return [];
    }
}
